import { BaseViewStore } from 'core/stores';
import { action, observable } from 'mobx';
import { FacilityOrderService } from '../../facility-order/services';

class PrimaryRecipientErrorModalStore extends BaseViewStore {
	@observable accessor isLoading = false;
	@observable accessor missingName = '';
	constructor(rootStore, componentsProps) {
        super(rootStore);

        this.rootStore = rootStore;
        this.facilityOrderId = componentsProps.modalParams.facilityOrderId;
        this.modalParams = componentsProps.modalParams;
        this.facilityOrderService = new FacilityOrderService(rootStore.application.baasic.apiClient);
        this.isNiko = componentsProps.modalParams.isNiko;
        this.processAction = componentsProps.modalParams.data.processAction;
        this.missingName = componentsProps.modalParams.data.missingName;
    }

	@action.bound
	async isDoneCheck() {
		this.isLoading = true;
		
		await new Promise(resolve => setTimeout(resolve, 1500));
		const recipientData = this.isNiko
			? (await this.facilityOrderService.hasPrimaryRecipientNiko(this.facilityOrderId)).data
			: (await this.facilityOrderService.hasPrimaryRecipient(this.facilityOrderId)).data;
		const hasPrimaryRecipientSet = recipientData.pickTicketRecipientType
		const hasPrimaryDeliveryRecipientSet = recipientData.deliveryTicketType;
		if (hasPrimaryRecipientSet && hasPrimaryDeliveryRecipientSet){
			this.isLoading = false;
			this.modalParams.close();
			await this.processAction('Send Pick Ticket');
		}

		this.missingName = [!hasPrimaryRecipientSet && "Packing List", !hasPrimaryDeliveryRecipientSet && "Delivery Ticket"].filter(Boolean).join(" and ");
		this.isLoading = false;
	}

}

export default PrimaryRecipientErrorModalStore;